import React from 'react';
import { SHADCN, TYPO, R } from '../theme';

// ── <ArticleTable> ───────────────────────────────────────────────────────────
// Table d'articles Square, pilotée par config de colonnes. Pattern partagé entre
// le Catalogue (articles_liste) et les buckets d'anomalies (audit TVA) : shell
// bordé + scroll horizontal, en-tête eyebrow, troncature et état vide intégrés.
//
// columns: [{
//   key,            // identifiant unique de colonne
//   label,          // libellé d'en-tête
//   align,          // 'left' (défaut) | 'right'
//   nowrap,         // empêche le retour à la ligne de la cellule
//   render(row),    // contenu de la cellule (défaut: row[key])
//   cellStyle,      // style td additionnel (objet ou fn(row) => objet)
// }]
const TD_BASE = { ...TYPO.body, color: SHADCN.fg, padding: '7px 10px' };
const TH_BASE = { ...TYPO.eyebrow, color: SHADCN.mutedFg, padding: '8px 10px' };

export default function ArticleTable({
  columns,
  rows,
  getKey = (r) => r.itemId,
  max,
  moreLabel = (n) => `+ ${n} autres`,
  emptyLabel = 'Aucun article.',
}) {
  const visible = max ? rows.slice(0, max) : rows;
  const overflow = max && rows.length > max ? rows.length - max : 0;

  return (
    <div style={{ overflowX: 'auto', border: `1px solid ${SHADCN.border}`, borderRadius: R.md }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: SHADCN.bg, borderBottom: `1px solid ${SHADCN.border}` }}>
            {columns.map((c) => (
              <th key={c.key} style={{ ...TH_BASE, textAlign: c.align || 'left' }}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {visible.map((row) => (
            <tr key={getKey(row)} style={{ borderBottom: `1px solid ${SHADCN.border}` }}>
              {columns.map((c) => {
                const extra = typeof c.cellStyle === 'function' ? c.cellStyle(row) : c.cellStyle;
                return (
                  <td key={c.key} style={{
                    ...TD_BASE,
                    textAlign: c.align || 'left',
                    ...(c.nowrap ? { whiteSpace: 'nowrap' } : null),
                    ...extra,
                  }}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {overflow > 0 && (
        <div style={{ ...TYPO.caption, color: SHADCN.mutedFg, padding: '6px 10px', textAlign: 'center' }}>
          {moreLabel(overflow)}
        </div>
      )}
      {rows.length === 0 && (
        <div style={{ ...TYPO.body, color: SHADCN.mutedFg, padding: '14px 10px', textAlign: 'center' }}>
          {emptyLabel}
        </div>
      )}
    </div>
  );
}
